import styled from '@emotion/styled';
import React from 'react';

import { color, font, shadow } from 'src/shared/styles/variables';

import { AdditonalSupportResource } from '../models/pfaProgram';
import { AdditionalSupportResources } from './AdditionalSupportResources';

const BoxWrapper = styled('div')({
    backgroundColor: color.white,
    borderRadius: '0.5rem',
    margin: '2rem 0',
    boxShadow: shadow.lightCardShadow,
    height: '100%',
    padding: '1.5rem',
});

const Heading = styled('h3')(
    {
        color: color.blueLagoon,
        margin: '2.5rem 0 1rem',
        borderBottom: `2px solid ${color.blueLagoon}`,
        width: '100%',
        paddingBottom: '0.5rem',
    },
    font.heavy(font.size.mediumExtended),
);

interface Props {
    resources: AdditonalSupportResource[];
    title: string;
}

export const AdditionalSupportBox: React.SFC<Props> = ({ resources, title }) => (
    <BoxWrapper>
        <Heading>{title}</Heading>
        {resources.map(resource => (
            <AdditionalSupportResources key={resource.topic} resource={resource} />
        ))}
    </BoxWrapper>
);
